import { EventState, EventStateType } from '@bp/planung-graphql-types';
import { SubstitutionFormRowStatus } from '../../../../components/Substitutions/forms/SubstitutionFormRow';

export type SubstitutionDataEntry = {
  uuid: string;
  name: string;
  shortName: string;
};

export type SubstitutionDataTeacherEntry = SubstitutionDataEntry & {
  status: Extract<SubstitutionFormRowStatus, 'cancellation-school-event' | 'normal'>;
  givenSubstituteHours: number | null;
};

export type SubstitutionDataMissingTeacherEntry = SubstitutionDataEntry & {
  status: Extract<SubstitutionFormRowStatus, 'on-school-event' | 'signed-out'>;
  fullDay: boolean;
  state?: EventState;
};

export type SubstitutionDataSubstitutionTeacherEntry = SubstitutionDataEntry & {
  status: Extract<SubstitutionFormRowStatus, 'substitution'>;
  givenSubstituteHours: number | null;
};

export const createMapFromArray = <T extends { uuid: string }>(array: T[]) => {
  return new Map<string, T>(array.map((item) => [item.uuid, item]));
};

export const mapTeachers = (
  personsConnection: {
    edges: { node: { uuid: string } }[];
  },
  teacherMap: Map<string, { uuid: string; displayName: string; shortName: string }>,
  hasClassesOrGroups: boolean,
): SubstitutionDataTeacherEntry[] => {
  return personsConnection.edges.map((edge: any) => {
    const teacher = teacherMap.get(edge.node.uuid);
    return {
      uuid: teacher?.uuid ?? '',
      name: teacher?.displayName ?? '',
      shortName: teacher?.shortName ?? '',
      status: hasClassesOrGroups ? 'cancellation-school-event' : 'normal',
      givenSubstituteHours: edge.properties.givenSubstituteHours ?? null,
    };
  });
};

export const mapSubstitutionTeachers = (
  personsConnection: {
    edges: {
      node: { uuid: string };
      properties: { isCoveringTeacher: boolean; givenSubstituteHours?: number | null };
    }[];
  },
  teacherMap: Map<string, any>,
): SubstitutionDataSubstitutionTeacherEntry[] => {
  return personsConnection.edges
    .filter((edge: any) => edge.properties.isCoveringTeacher)
    .map((edge: any) => {
      const teacher = teacherMap.get(edge.node.uuid);
      return {
        uuid: teacher?.uuid ?? '',
        name: teacher?.displayName ?? '',
        shortName: teacher?.shortName ?? '',
        status: 'substitution',
        givenSubstituteHours: edge.properties.givenSubstituteHours ?? null,
      };
    });
};

export const parseState = (state?: string | null): Partial<EventStateType>[] => {
  if (!state) {
    return [];
  }
  try {
    const parsedState = JSON.parse(state);
    if (typeof parsedState === 'object' && parsedState !== null) {
      return parsedState as Partial<EventStateType>[];
    }
    console.warn('Parsed state is not an object:', parsedState);
    return [];
  } catch (error) {
    console.error('Failed to parse state:', error);
    return [];
  }
};
